/*!
 * el-table-infinite-scroll v2.0.3
 * (c) 2019-2025 yujinpan
 */

import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.array.concat.js';
import InfiniteScroll from 'element-ui/lib/infinite-scroll';
import { syncAttrs } from './utils.js';

var elScope = 'ElInfiniteScroll';
var msgTitle = '[el-table-infinite-scroll]: ';
var elTableScrollWrapperClass = '.el-table__body-wrapper';
var ElTableInfiniteScroll = {
  inserted: function inserted(el, binding, VNode, oldVNode) {
    var scrollElem = el.querySelector(elTableScrollWrapperClass);
    if (!scrollElem) {
      throw new Error("".concat(msgTitle).concat(elTableScrollWrapperClass, " element not found."));
    }
    scrollElem.style.overflowY = 'auto';

    // after render
    setTimeout(function () {
      if (!el.style.height) {
        scrollElem.style.height = '400px';
        // eslint-disable-next-line
        console.warn("".concat(msgTitle, " el-table height required, otherwise will set default value: 400px"));
      }
      syncOptions(el, scrollElem);

      // use `InfiniteScroll`
      InfiniteScroll.inserted(scrollElem, binding, VNode, oldVNode);

      // used by unbind, destroy listener events
      el[elScope] = scrollElem[elScope];
    }, 0);
  },
  componentUpdated: function componentUpdated(el) {
    syncOptions(el, el.querySelector(elTableScrollWrapperClass));
  },
  unbind: InfiniteScroll.unbind
};
function syncOptions(sourceElem, targetElem) {
  syncAttrs(sourceElem, targetElem, ['infinite-scroll-disabled', 'infinite-scroll-delay', 'infinite-scroll-immediate', 'infinite-scroll-distance']);

  // fix: windows/chrome `scrollTop + clientHeight` is difference with `scrollHeight`
  var name = 'infinite-scroll-distance';
  var value = +sourceElem.getAttribute(name) || 0;
  targetElem.setAttribute(name, (value < 1 ? 1 : value) + '');
}

export { ElTableInfiniteScroll as default };
